import { render, staticRenderFns } from "./centurion-travel-main.vue?vue&type=template&id=588c3290&scoped=true&"
import script from "./centurion-travel-main.vue?vue&type=script&lang=js&"
export * from "./centurion-travel-main.vue?vue&type=script&lang=js&"
import style0 from "./centurion-travel-main.vue?vue&type=style&index=0&id=588c3290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c3290",
  null
  
)

export default component.exports